import { render, staticRenderFns } from "./SectionsCreate.vue?vue&type=template&id=72e535a8"
import script from "./SectionsCreate.vue?vue&type=script&lang=js"
export * from "./SectionsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports